import { UserType } from './../model/userType.model';
import { catchError } from 'rxjs/operators';
import { EnvService } from './../../services/env.service';
import { IClaimRequest, IClaimResponse } from "../model/claim.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";



@Injectable()
export class ClaimService {
  constructor(private http: HttpClient, private env:EnvService) {}

  postClaimData(claim: IClaimRequest): Observable<IClaimResponse> {
    const baseUrl = this.env.apiBaseUrls;
    let url = `${baseUrl}/account/claim_validate`;
    let options = {headers: new HttpHeaders({'Content-Type':'application/json'})}    
    return this.http.post<IClaimResponse>(url, claim,options)
    .pipe(catchError(this.handleError<IClaimResponse>('postClaimData')))
            
  }

  private handleError<T> (operation ='operation', result?:T){
    return (error: any): Observable<T> => {
      console.error(error)
      return of(result as T)
    }
  }
  allUserTypes(): UserType[] {
    let userTypes = [
      new UserType(1, 'student'),
      new UserType(2, 'employee')
    ]	 
    return userTypes;	  
 }
}
